import { inject } from '@angular/core';
import { CanActivateFn, CanMatchFn, Router } from '@angular/router';
import { paths } from '@platform/paths';
import { MaintenanceService } from '@shared/services/maintenance.service';
import { map } from 'rxjs/operators';

/** Sends every app route to /maintenance while maintenance mode is on. */
export const maintenanceModeGuard: CanMatchFn = () => {
  const router = inject(Router);
  return inject(MaintenanceService)
    .isMaintenanceModeEnabled()
    .pipe(map((enabled) => (enabled ? router.createUrlTree([paths.MAINTENANCE]) : true)));
};

/** Leaves /maintenance and goes back into the app once maintenance mode is off. */
export const maintenancePageGuard: CanActivateFn = () => {
  const router = inject(Router);
  return inject(MaintenanceService)
    .isMaintenanceModeEnabled()
    .pipe(map((enabled) => (enabled ? true : router.createUrlTree(['/']))));
};
